// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__26rrW","unreadBadge":"styles_unreadBadge__2jKaK","modalContent":"styles_modalContent__PS099","modal":"styles_modal__13W2w"};